import Layout from "antd/lib/layout";
import Link from "next/link";

import { Route, interpolate } from "@sol/routing";
import { getResourceUuid, usePageListQuery, PageStatus } from "@sol/sdk";
import { Button } from "@sol/uikit/general/Button/Button";

import SupportButton from "./SupportButton";

type Props = {
    noFooterMargin?: boolean;
    className?: string;
};
const { Footer } = Layout;

export function AuthenticatedLayoutFooter({ className }: Props) {
    const { data: pages } = usePageListQuery({ filters: { status: PageStatus.PUBLISHED } });

    return (
        <Footer className={className} role="contentinfo">
            <ul className="flex list-none flex-col items-center justify-between lg:flex-row lg:gap-ant">
                {pages &&
                    pages["hydra:member"].map(page => {
                        const pageUUID = getResourceUuid(page);
                        return (
                            <li key={pageUUID}>
                                <Link href={interpolate(Route.PAGE, { pageUUID })} passHref>
                                    <Button type="link">{page.title}</Button>
                                </Link>
                            </li>
                        );
                    })}
                <li>
                    <SupportButton />
                </li>
            </ul>
        </Footer>
    );
}
